import { AustralianState } from '@urbanx/agx-ui-components';
import { FormType } from '@urbanx/agx.campaigns.client';
import { ApiRequestBody } from 'interfaces/ApiRequestBody';
import CampaignsService from 'services/campaignsService';

interface FormSubmission extends ApiRequestBody {
  CampaignId: string;
  FormId?: string;
  FormType: FormType;
  State: AustralianState;
  BlankContractIsLive: boolean;
  FormData: object;
  NotifyAgent: boolean;
}

export interface FormSubmissionResponse {
  errors: string[];
  blankContractIsLive: boolean;
}

const submitForm = async (
  requestBody: FormSubmission
): Promise<FormSubmissionResponse | undefined> => {
  const { getAuthToken, ...requestProperties } = requestBody;

  const token = await getAuthToken();

  const service = new CampaignsService(token);

  const result = await service.campaignsService.post('StaffSubmitForm', {
    ...requestProperties,
  });

  return result.data as FormSubmissionResponse;
};

export default submitForm;
